import http from '@/utils/http'
import apis from '@/utils/apis'
import Vue from 'vue'
export default {
  async GET_MEETING_INFO({ commit, state },callback) {
    const res = await http.get(`${apis.getMeetingInfo}/${state.meetingId}`) 
  }
}